import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const createExamPlanning = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/coursedte/create`,
    payload,
    {
      headers: setHeaders(context),
      withCredentials: setHeaders(context).withCredentials,
    },
  );
  return response.data;
};

export const updateExamPlanning = async (idExam, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/coursedte/${idExam}`,
    payload,
    {
      headers: setHeaders(context),
      withCredentials: setHeaders(context).withCredentials,
    },
  );
  return response.data;
};

export const deleteExamPlanning = async (idExam, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/coursedte/delete/${idExam}`,
    {
      headers: setHeaders(context),
      withCredentials: setHeaders(context).withCredentials,
    },
  );
  return response.data;
};

export const getClassExamPlanning = async (idClass, idPeriod, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/coursedte/classedte/${idClass}/${idPeriod}`,
    {
      headers: setHeaders(context),
      withCredentials: setHeaders(context).withCredentials,
    },
  );
  return response.data;
};

export const getStudentExamPlanning = async (
  idStudent,
  idClass,
  idPeriod,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/coursedte/student/${idStudent}/${idClass}/${idPeriod}`,
    {
      headers: setHeaders(context),
      withCredentials: setHeaders(context).withCredentials,
    },
  );
  return response.data;
};

export const getClassExamPlanningById = async (idExam, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/coursedte/${idExam}`,
    {
      headers: setHeaders(context),
      withCredentials: setHeaders(context).withCredentials,
    },
  );
  return response.data;
};

// --------------------------PDF-------------------------------------------------------

export const generateClassExamPlanning = async (idClass, idPeriod, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/pdf/generate-edte/${idClass}/${idPeriod}`,
    {
      headers: setHeaders(context),
      responseType: "blob",
    },
  );
  return response.data;
};

export const generateExamEnveloppe = async (idClass, idPeriod, context) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/pdf/generate-enveloppeEpreuve/${idClass}/${idPeriod}`,
    {
      headers: setHeaders(context),
      responseType: "blob",
    },
  );
  return response.data;
};
